module.exports = __webpack_public_path__ + "img/logoDark.74e30eba.png";